import { render, staticRenderFns } from "./SexNumStatistical.vue?vue&type=template&id=273e4ea6&scoped=true&"
import script from "./SexNumStatistical.vue?vue&type=script&lang=js&"
export * from "./SexNumStatistical.vue?vue&type=script&lang=js&"
import style0 from "./SexNumStatistical.vue?vue&type=style&index=0&id=273e4ea6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e4ea6",
  null
  
)

export default component.exports